import fetch from "auth/FetchInterceptor";
import { API_BASE_URL} from "configs/AppConfig";

const AuthService = {};

AuthService.login = async function (data) {
  // return {
  //   message: "Authentication Successfull",
  //   user: {
  //     company_id: "f3aa7826a1",
  //     user_id: "72562584ce",
  //     company_name: "Pilot Company",
  //     token:
  //       "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImxpdmVseXh5ekBnbWFpbC5jb20iLCJ1c2VySWQiOiI2NDNlYTk5MmQzYzg1ZGZlZGY1NTM4NWMiLCJpYXQiOjE2ODMwNDIzMTgsImV4cCI6MTcxNDU3ODMxOH0.YsGi-UWrqWnmvnitwwgS3V2g1XoQeqEWXeSf0JRdsDU",
  //   },
  // };

  // const res = await fetch(`${API_BASE_URL}/user/login`, {
  //   method: "post",
  //   // data: data,
  //   body: JSON.stringify(data),
  // });

  // const response = await res.json();
  // console.log(response);
  // return response;

  return fetch({
    url: `${API_BASE_URL}/user/login`,
    method: "post",
    data: data,
  });
};

AuthService.register = async function (data,hasShopDomain,hasAPPSumo) {
  if(hasShopDomain){
    return fetch({
      url: `${API_BASE_URL}/user/signup`,
      method: "post",
      headers: {
        "X-REQUEST-SOURCE": "SHOPIFY-APP"
      },
      data: data,
    });
  }
  else{
    if(hasAPPSumo){
      return fetch({
        url: `${API_BASE_URL}/user/signup`,
        headers: {
          "X-REQUEST-SOURCE": "APPSUMO"
        },
        method: "post",
        data: data,
      });
    }
    else{
      return fetch({
        url: `${API_BASE_URL}/user/signup`,
        method: "post",
        data: data,
      });
    }
  }
};

AuthService.logout = function () {
  return fetch({
    url: "/auth/logout",
    method: "post",
  });
};

AuthService.loginInOAuth = function () {
  return fetch({
    url: "/auth/loginInOAuth",
    method: "post",
  });
};

AuthService.forgotPassword= async function(data){
  return fetch({
    url: `/user/forgetPassword`,
    method: "post",
    data: data,
  });
}

AuthService.resetPassword= async function(data){
  return fetch({
    url: `/user/forgetPasswordVerification`,
    method: "post",
    data: data,
  });
}

AuthService.ssoAuthentication= async function(data){
  return fetch({
    url: `${API_BASE_URL}/user/validate-sso-link`,
    method: "get",
    params: data
  });
}

AuthService.checkAppSumoOnboarded= async function(data){
  return fetch({
    url: `${API_BASE_URL}/app-sumo/oauth/callback`,
    method: "get",
    params: data
  });
}

export default AuthService;
